import { createDecagonClient } from '@user-portal/chatbot';

import api from '@/api';

export const decagonClient = createDecagonClient({
    projectId: 'menscoach',
    source: 'web-cabinet',
    env: import.meta.env.ENV === 'prod' ? 'prod' : 'stage',
});

export const initDecagonClient = async () => {
    if (!decagonClient.isNotInitialised) return;
    try {
        const { token: handoffToken } = await api.user.getTokenHandoff();
        await decagonClient.initialise({ handoffToken });
    } catch {
        // retried on click
    }
};
